<template>
  <main>
    <!-- <section>
      <h2>
        <nuxt-link to="/updates?type=comics">
          Обновления Комиксов манга
        </nuxt-link>
      </h2>
      <div class="slider comics">
        <ul :style="`width: ${updates.length * 350}px`">
          <li v-for="item in updates" :key="`comics-update-${item.date}`">
            <div class="post-body">
              <div class="poster">
                <img :src="item.poster" :alt="item.title">
              </div>
              <div class="post-info">
                <strong v-if="item.title.length > 50">{{ item.title.slice(0, 50) }}...</strong>
                <strong v-else>{{ item.title }}</strong>
                <span v-if="item.update">{{ item.update }}</span>
              </div>
              <nuxt-link :to='`/comics/${postUrl(item.id, item.title)}`'>
                {{ item.title }}
              </nuxt-link>
            </div>
          </li>
        </ul>
      </div>
    </section> -->

    <section class="comics">
      <h1>
        Комиксы манга, манхва, маньхуа, веб-манхва на русском
        <span v-if="type"> - {{ type }}</span>
        <span v-if="genre"> жанра {{ genre }}</span>
        <span v-if="author"> - автор {{ author }}</span>
        <span v-if="translation"> - перевод {{ translation }}</span>
      </h1>

      <div @click="showFilters = !showFilters" :class="{ active: showFilters }" class="sort-btn">
        <i class="sort-icon" />
        <span>Фильтры</span>
      </div>

      <transition name="toRight">
        <div v-if="showFilters" class="sorting-block">
          <i v-if="!loading" @click="showFilters = !showFilters" class="close" />
          <i v-else class="loader" />

          <div>
            <strong>Тип</strong>
            <label for="type">
              <select id="type" v-model="type" @change="getData(1)">
                <option value="">Все комиксы</option>
                <option value="Манга">Манга</option>
                <option value="Манхва">Манхва</option>
                <option value="Маньхуа">Маньхуа</option>
                <option value="Веб-манхва">Веб-манхва</option>
              </select>
            </label>

            <label for="new">
              <input id="new" v-model="newComics" @change="getData(1)" type="checkbox">
              <span>Новинки</span>
            </label>
          </div>

          <div class="genres">
            <strong>Жанры</strong>
            <label for="genres">
              <label v-for="(g, i) in genres" :key="`comics-genre-${i}`" :for="g">
                <input :id="g" @change="getData(1)" type="checkbox">
                <span>{{ g }}</span>
              </label>
            </label>
          </div>
        </div>
      </transition>

      <searchhints-component :type="'comics'" />

      <!-- <div v-if="isDesktop" class="views">
        <strong>Вид</strong>
        <span :class="{ active: listView === '1' }" @click="listView = '1'">1</span>
        <span :class="{ active: listView === '2' }" @click="listView = '2'">2</span>
      </div> -->

      <div v-if="comics.length" :class="{ columns: listView === '2' }" class="comics-list">
        <strong v-if="page > 1">Страница {{ page }}</strong>
        <article v-for="comic in comics" :key="`index-comics-${comic._id}`" class="comics-item">
          <div class="content">
            <div>
              <div class="poster">
                <fav-component :fav="comic" />
                <img src="/static_files/no-poster.png" :data-src="comic.poster" :alt="`Постер к комиксу ${comic.title}`" class="lazyload" />
              </div>
              <div class="read">
                <nuxt-link :to='`/comics/${postUrl(comic.id, comic.title)}?q=0`'>
                  Читать
                </nuxt-link>
              </div>
            </div>
            <div class="info">
              <span class="category">{{ comic.category }}</span>
              <span
              :class="{
                green: comic.status.trim() === 'Продолжается',
                red: comic.status.trim() === 'Завершен'
              }"
              class="status"
              >{{ comic.status }}</span>
              <ul v-if="comic.genres && comic.genres.length" class="genres">
                <li>
                  <nuxt-link :to='`/comics?year=${comic.year}`'>{{ comic.year }}</nuxt-link>
                </li>
                <li v-for="g in comic.genres.slice(0, 2)" :key="`comics-genre-${g}`">
                  <nuxt-link :to='`/comics?genre=${g}`'>{{ g }}</nuxt-link>
                </li>
              </ul>
              <h2><nuxt-link :to='`/comics/${postUrl(comic.id, comic.title)}`'>{{ comic.title }}</nuxt-link></h2>
              <div v-if="isDesktop" class="body">
                  <strong>Авторы:</strong>
                <ul class="author">
                  <li v-for="a in comic.author" :key="`comics-author-${a}`">
                    <nuxt-link :to='`/comics?author=${a}`'>{{ a }}</nuxt-link>
                  </li>
                </ul>
                <strong>Перевод:</strong>
                <ul class="translation">
                  <li v-for="t in comic.translation" :key="`comics-translation-${t}`">
                    <nuxt-link :to='`/comics?translation=${t}`'>{{ t }}</nuxt-link>
                  </li>
                </ul>
                <p class="desc">{{ comic.desc }}</p>
                <!-- <p class="update">{{ comic.update }}</p> -->
              </div>
              <div v-else class="body">
                <p class="desc">{{ comic.desc.slice(0, 200) }}...</p>
                <nuxt-link :to="`/comics/${postUrl(comic.id, comic.title)}`">Читать далее</nuxt-link>
              </div>
            </div>
          </div>
        </article>
      </div>

      <strong v-if="page > 1">Страница {{ page }}</strong>

      <div
        v-if="page < pages"
        @click="getMoreData(++page)"
        class="show-more"
      >
        <span v-if="!loading">Показать еще</span>
        <i v-else class="loader" />
      </div>

      <div v-if="pages > 1" class="pagination">
        <ul :style="paginationSliderWidth">
          <li v-for="p in pagesArr" :key="`comics-page-${p}`">
            <span @click="goTo(p)"
              :class="{ active: p == page }"
            >
              {{ p }}
            </span>
          </li>
          <li v-if="pages > 10">
            <span>...</span>
          </li>
          <li v-if="pages > 10">
            <span @click="goTo(p)"
              :class="{ active: pages == page }"
            >
              {{ pages }}
            </span>
          </li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    searchhintsComponent: () => import('~/components/searchhintsComponent.vue'),
    favComponent: () => import('~/components/favComponent.vue')
  },
  head() {
    const page = this.page ? '. Cтраница ' + this.page : ''
    const type = this.type ? this.type : 'манга, манхва, маньхуа и веб-манхва'
    const genre = this.genre ? ' жанра ' + this.genre : ''
    const year = this.year ? ` за ${this.year} год` : ''
    const author = this.author ? ` - ${this.author}` : ''
    const translation = this.translation ? ` - ${this.translation}` : ''
    const canonical = `https://anime777.ru/comics?page=${this.page}${
      this.type ? `&type=${type}` : ''
    }${
      this.genre ? `&genre=${genre}` : ''
    }${
      this.year ? `&year=${year}` : ''
    }${
      this.author ? `&author=${author}` : ''
    }${
      this.translation ? `&translation=${translation}` : ''
    }`
    const title = `Читайте комиксы ${type}${genre}${year}${author}${translation} онлайн бесплатно на русском${page}`
    const description = `На нашем сайте вы можете почитать онлайн ${type}${genre}${year}${author}${translation} бесплатно на русском и в хорошем качестве изображения.${page}`
    return {
      title: title,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: canonical
        }
      ],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `комиксы ${type}${genre}${year}${author}${translation}`
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: canonical
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: description
        }
      ]
    }
  },
  watch: {
    listView() {
      localStorage.setItem('comics_view', this.listView)
    },
    showFilters(val) {
      // const list = document.querySelectorAll('.genres input[type="checkbox"]')
      // list.forEach(el => {
      //   el.checked = ch
      // })
      setTimeout(() => {
        if (this.genre) {
          const genres = this.genre.split(',')
          if (genres.length) {
            genres.forEach((e) => {
              const elem = document.querySelector(`.genres input#${e}`)
              if (elem) elem.checked = true
            })
          }
        }

        if (this.year) {
          const years = this.year.split(',')
          if (years.length) {
            years.forEach((e) => {
              const elem = document.querySelector(`.years input#${e}`)
              if (elem) elem.checked = true
            })
          }
        }
      }, 500)
    }
  },
  watchQuery: ['page', 'type', 'genre', 'year', 'author', 'translation', 'new'],
  computed: {
    ...mapState(['isDesktop']),
    pagesArr() {
      const pages = +this.pages
      const page = +this.page

      let arr = 0

      if (pages > 10) {
        const diff = pages - page > 10 ? 9 + page : page + (pages - page)
        arr = diff
      } else {
        arr = pages
      }

      return arr
    },
    paginationSliderWidth() {
      const width = this.pagesArr + 3
      const str = `width: ${width * 63}px`
      return str
    }
  },
  data() {
    return {
      listView: '1',
      gets: {}
    }
  },
  async asyncData({ $axios, query }) {
    // if (Object.keys(query).length) {
    //   Object.keys(query).forEach(key => {
    //     query[key] = query[key].replace('.html', '')
    //   })
    // }

    const page = query.page ? query.page : 1
    const type = query.type ? query.type : ''
    const genre = query.genre ? query.genre : ''
    const year = query.year ? query.year : ''
    const author  = query.author  ? query.author  : ''
    const translation = query.translation ? query.translation : ''
    const newComics = query.new ? query.new : false
    let url = `/api/comics?page=${page}`
    if (query.type) url += `&type=${encodeURIComponent(type)}`
    if (query.genre) url += `&genre=${encodeURIComponent(genre)}`
    if (query.year) url += `&year=${encodeURIComponent(year)}`
    if (query.author) url += `&author=${encodeURIComponent(author)}`
    if (query.translation) url += `&translation=${encodeURIComponent(translation)}`
    if (newComics) url += `&new=${encodeURIComponent(newComics)}`
    const { data } = await $axios.get(url)
    // console.log('data', data)
    return {
      loading: false,
      gets: {},
      page,
      pages: data.pages,
      comics: data.items,
      updates: data.updates,
      type,
      genre,
      year,
      author,
      translation,
      searchQuery: '',
      searchItems: [],
      genres: [
        'боевые искусства', 'боевик', 'вампиры', 'гарем', 'гендерная интрига', 'героическое фэнтези', 'додзинси',
        'дзёсэй', 'драма', 'детектив', 'игра', 'история', 'киберпанк', 'комедия', 'мистика',
        'меха', 'махо-сёдзё', 'научная фантастика', 'перерождение', 'повседневность', 'приключения',
        'психология', 'романтика', 'самурайский боевик', 'сборник', 'сверхъестественное', 'сёдзё',
        'сёдзё для взрослых', 'сёдзё-ай', 'сёнэн', 'сёнэн-ай', 'спокон', 'сэйнэн', 'спорт', 'трагедия',
        'триллер', 'ужасы', 'фантастика', 'фэнтези', 'школа', 'эротика', 'этти', 'юри', 'яой'
      ],
      newComics,
      showFilters: false
    }
  },
  mounted() {
    if (this.isDesktop && localStorage.getItem('comics_view')) {
      this.listView = localStorage.getItem('comics_view')
    }

    const pUl = document.querySelectorAll('.pagination')
    if (pUl) {
      pUl.forEach(el => {
        el.scrollTo((this.page - 2) * 59, 0)
      })
    }
  },
  methods: {
    async getData(page = 1) {
      if (this.gets.getData) return
      this.gets.getData = true

      this.loading = true

      const list = document.querySelectorAll('.genres input[type="checkbox"]')
      const arr = []
      list.forEach(el => {
        if (el.checked) arr.push(el.getAttribute('id'))
      })
      this.genre = arr.join(',')

      let url = `/api/comics?page=${page}`
      if (this.type) url += `&type=${encodeURIComponent(this.type)}`
      if (this.genre) url += `&genre=${encodeURIComponent(this.genre)}`
      if (this.year) url += `&year=${encodeURIComponent(this.year)}`
      if (this.author) url += `&author=${encodeURIComponent(this.author)}`
      if (this.translation) url += `&translation=${encodeURIComponent(this.year)}`
      if (this.newComics) url += `&new=${encodeURIComponent(this.newComics)}`

      const { data } = await this.$axios.get(url)
      this.comics = data.items
      this.pages = data.pages
      this.page = page
      this.$nextTick(() => {
        this.lazyLoadImgs()
      })
      this.loading = false
      delete this.gets.getData
    },
    goTo(page = 1) {
      const list = document.querySelectorAll('.genres input[type="checkbox"]')
      const arr = []
      list.forEach(el => {
        if (el.checked) arr.push(el.getAttribute('id'))
      })
      this.genre = arr.join(',')

      let url = `/comics?page=${page}`
      if (this.type) url += `&type=${encodeURIComponent(this.type)}`
      if (this.genre) url += `&genre=${encodeURIComponent(this.genre)}`
      if (this.year) url += `&year=${encodeURIComponent(this.year)}`
      if (this.author) url += `&author=${encodeURIComponent(this.author)}`
      if (this.translation) url += `&translation=${encodeURIComponent(this.year)}`
      if (this.newComics) url += `&new=${encodeURIComponent(this.newComics)}`
      this.$router.push(url)
    },
    async getMoreData(page = 1) {
      let url = `/api/comics?page=${page}`
      if (this.type) url += `&type=${encodeURIComponent(this.type)}`
      if (this.genre) url += `&genre=${encodeURIComponent(this.genre)}`
      if (this.year) url += `&year=${encodeURIComponent(this.year)}`
      if (this.author) url += `&author=${encodeURIComponent(this.author)}`
      if (this.translation) url += `&translation=${encodeURIComponent(this.year)}`
      if (this.newComics) url += `&new=${encodeURIComponent(this.newComics)}`
      const { data } = await this.$axios.get(url)
      this.comics = this.comics.concat(data.items)
      this.pages = data.pages
      this.page = page
      this.$nextTick(() => {
        this.lazyLoadImgs()
        const pUl = document.querySelectorAll('.pagination')
        if (pUl) {
          pUl.forEach(el => {
            el.scrollTo((this.page - 2) * 59, 0)
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.comics
  .views
    margin-bottom 20px
    text-align left
    strong
      margin-right 5px
    span
      margin 0 2px
      padding 5px 10px
      color #000
      background-color #fff
      border 1px solid #eee
      border-radius 5px
      cursor pointer
      &.active
        font-weight bold
  .comics-list.columns
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 20px
    h2
      font-size 2.4rem
    .comics-item .body .desc
      display none
</style>
